import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Tag as TagIcon } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import { useKeysDown } from 'shared/hooks/use-keys-down';
import { Paths } from 'shared/routes/paths';
import { ID } from 'shared/types/id';
import { Tag } from 'shared/types/tag';

import * as Styled from './search-tag-card.style';

export type SearchTagCardProps = {
  tag: Tag;
  onClick?: (id: ID) => void;
  tabbable?: boolean;
  navTo?: string;
};

export const SearchTagCard: React.FC<SearchTagCardProps> = ({
  tag,
  onClick,
  tabbable,
  navTo,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  const _onClick = (e: React.MouseEvent | KeyboardEvent) => {
    e.stopPropagation();
    e.preventDefault();
    navigate(navTo ?? Paths.TagDetail.replace(':id', tag.id));
    onClick?.(tag.id);
  };

  useKeysDown(
    ['Enter'],
    (e) => {
      if (tabbable && document.activeElement === containerRef.current) {
        _onClick(e);
      }
    },
    { otherKeysInCombinationAllowed: true },
  );

  return (
    <Styled.Container
      ref={containerRef}
      onClick={_onClick}
      $isClickable
      tabIndex={tabbable ? 0 : undefined}
    >
      <Styled.IconContainer $color={tag.color}>
        <Icon icon={TagIcon} />
      </Styled.IconContainer>

      <Styled.Title>{tag.name}</Styled.Title>
    </Styled.Container>
  );
};
